import { createSlice } from "@reduxjs/toolkit"

const initialState={
    notiAction:false
}

const notificationSlice=createSlice({
    name:"notification",
    initialState,
    reducers:{
        notify:(state,action)=>{
            state.notiAction=action.payload.message
        },
   
    
    }
})

export const {notify}=notificationSlice.actions;

export default notificationSlice.reducer;